import React from "react";
import { ShieldCheck, Music4, Star, Crown } from "lucide-react";

const STAFF = {
  super_admin: { label: "Admin", color: "#D4AF37", Icon: ShieldCheck },
  admin: { label: "Admin", color: "#9D4EDD", Icon: ShieldCheck },
  instructor: { label: "Instructor", color: "#5CC8FF", Icon: Music4 },
  artist: { label: "Artist", color: "#F59E0B", Icon: Star },
  vip: { label: "VIP", color: "#EC4899", Icon: Crown },
};

export default function RoleBadge({ role, size = "sm", className = "" }) {
  const s = STAFF[role];
  if (!s) return null;
  const { label, color, Icon } = s;
  const px = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  const ic = size === "xs" ? 9 : 11;
  return (
    <span data-testid={`role-badge-${role}`} className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wide shrink-0 ${px} ${className}`}
      style={{ background: `${color}22`, color }}>
      <Icon size={ic} /> {label}
    </span>
  );
}
